import {AfterViewInit, Component, EventEmitter, Injector, Input, OnInit, Output} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {SpecialistsService} from '@providers/specialists/specialists.service';
import {SpecialistsProvider} from '@providers/specialists/specialists.provider';
import {SpecialistViewInterface} from '@interfaces/specialist.interface';
import {EventsService} from '@services/events.service';
import {ErrorLoggerService} from '@services/error-logger.service';
import {AuthService} from '@services/auth.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {SpecialistStatusesProvider} from '@providers/specialist-statuses/specialist-statuses.provider';
import {SpecialistEnums} from '@namespaces/specialist.namespace';
import {ScrollToService} from '@services/scroll-to.service';

@Component({
    selector: 'app-specialist-form',
    templateUrl: 'specialist-form.component.html'
})

export class SpecialistFormComponent extends FrontendFormComponent implements AfterViewInit {
    @Input() specialist: SpecialistViewInterface;

    @Input() saveButtonName = 'Сохранить';

    @Input() showNavigation = false;

    @Input() scrollToElementId: string;

    @Output() saved = new EventEmitter<number>();

    public id: number;

    public anchors = [
        {title: 'Личные данные', targetId: 'personal', error: false},
        {title: 'Должность и стаж', targetId: 'job', error: false},
        {title: 'Размеры спецодежды', targetId: 'sizes', error: false},
        {title: 'Контактные данные', targetId: 'contacts', error: false},
        {title: 'Паспортные данные', targetId: 'passport', error: false},
        {title: 'Образование', targetId: 'education', error: false},
        {title: 'Допуски и разрешения', targetId: 'permits', error: false},
        {title: 'Медицинская справка', targetId: 'medical', error: false},
        {title: 'Удостоверения НК', targetId: 'certificate-nk', error: false},
        {title: 'Удостоверения ПБ', targetId: 'certificate-pb', error: false}
    ];

    public allowStatusChange = false;

    constructor(
        injector: Injector,
        public formService: SpecialistsService,
        public statusesProvider: SpecialistStatusesProvider,
        private specialistsProvider: SpecialistsProvider,
        private events: EventsService,
        private logger: ErrorLoggerService,
        private authSerive: AuthService,
    ) {
        super(injector);
    }

    init() {
        this.form = this._fb.group({
            status: [SpecialistEnums.Status.working], // Статус. По-умолчанию "Работает",
            permits: this._fb.array([]), // Допуски и разрешения
        });

        if (this.specialist) {
            this.id = this.specialist.id;
            this.setFormValues(this.specialist, this.form);
        }

        if (!this.id) {
            this.anchors.push(
                {title: 'Разрешения', targetId: 'agreements', error: false},
            );
        }

        this.allowStatusChange = this.authSerive.hasPermissions([UserNamespace.Permission.specialistSetStatus]);
    }

    ngAfterViewInit(): void {
        if (this.scrollToElementId) {
            ScrollToService.toIntoViewById(this.scrollToElementId);
        }
    }

    setAnchorErrorStatus(targetId: string, valid: boolean) {
        if (!targetId) {
            return;
        }

        const anchor = this.anchors.find(a => a.targetId === targetId);

        if (!anchor) {
            return;
        }

        anchor.error = !valid;

        this.anchors = [...this.anchors];
    }

    afterSave() {
        const id = this.form.get('id').value;

        if (!id) {
            this.isPending = false;
            this.events.showNoty({
                type: 'warning',
                content: 'Не удалось получить параметры созданного специалиста, попробуйте попытку позднее'
            });
            this.logger.log(
                new Error('Cannot get specialist.id after creating new'),
                'В компоненте SpecialistFormComponent после создания/сохранения не удалось получить id специалиста'
            );
            return false;
        }

        /**
         * Поскольку редактирование может происходить «здесь и сейчас» в каком-нибудь компоненте выбора специалиста,
         * то после редактирования или создания специалиста нужно обновить его данные в провайдере, чтобы они тут же применились
         * в компоненте
         */
        this.specialistsProvider.updateItem(id).toPromise().then(() => {
            this.saved.emit(id);
            this.isPending = false;
        }, () => {
            this.isPending = false;
        });
    }
}
